import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import store from 'src/store';

export default function useDormancy() {
  const setDormancy = useSetAtom(store.dormancy.state);
  const resetDormancy = useResetAtom(store.dormancy.state);

  const initDormancy = () => {
    resetDormancy();
  };

  const setDormancyUserDetail = (value: any) => {
    setDormancy((prev) => ({ ...prev, userData: value }));
  };

  const setStateCategory = (value: any) => {
    setDormancy((prev) => {
      const { conditions } = prev;
      return {
        ...prev,
        conditions: {
          ...conditions,
          [value.category]: value.value,
        },
      };
    });
  };

  return {
    setDormancyUserDetail,
    setStateCategory,
    initDormancy,
  };
}
